<template>
  <div class="ai-visibility-citation-source-row">
    <source-summary
        :title="row.domain"
        :domain="row.domain"
    >
      <panel-badge v-if="row.isTrackedSite">
        Your site
      </panel-badge>
    </source-summary>
    <strong>{{ row.citationCount }}</strong>
  </div>
</template>

<script>
import PanelBadge from '../../../ui/display/PanelBadge.vue'
import SourceSummary from '../../../ui/display/SourceSummary.vue'

export default {
  name: 'CitationSourceRow',
  components: {
    PanelBadge,
    SourceSummary,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
  }
}
</script>

<style lang="scss" scoped>

.ai-visibility-citation-source-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 40px;
  align-items: center;
  gap: 12px;
  border-bottom: 1px dashed var(--v-gray13Color-base);
  padding: 13px 0;
}

.ai-visibility-citation-source-row:last-child {
  border-bottom: 0;
}

.ai-visibility-citation-source-row strong {
  color: var(--v-mainColor-base);
  font-size: 16px;
  text-align: right;
}
</style>
